import { Component, Prop, h, State, Element, Host } from '@stencil/core';
@Component({
  tag: 'pn-customernumber-selector-option',
  styleUrl: 'pn-customernumber-selector-option.scss',
})
export class PnProfileSelectorOption {
  @Element() hostElement: Element;

  @Prop() heading: string = '';
  @Prop() description: string = '';
  @Prop() url: string = '';

  render() {
    return (
      <Host>
        <a class="customernumberoption" href={this.url}>
          <span class="customernumberoption-text">
            <span class="customernumberoption-title">{this.heading}</span>
            <span class="customernumberoption-description">{this.description}</span>
            <slot />
          </span>
        </a>
      </Host>
    );
  }
}
